export const priorityCities = [
  "Ottawa",
  "Pembroke",
  "Petawawa",
  "Perth",
  "Arnprior",
  "Renfrew",
  "Carleton Place",
  "Rockland",
  "Cornwall",
  "Kingston",
];

export const regionalCoverage = [
  "the Ottawa Valley",
  "Lanark County",
  "Renfrew County",
  "Prescott and Russell",
  "Stormont, Dundas and Glengarry",
  "Leeds and Grenville",
  "Frontenac County",
  "eastern Ontario",
];
